/* eslint-disable no-unused-vars*/
import React from 'react';
/* eslint-enable no-unused-vars*/
import {useIntl} from 'react-intl';

const customDateFormat = (dateString, format = 'd M Y') => {
  const date = createNewDate(dateString);

  const intl = useIntl();
  let formattedString = '';
  switch (format) {
    case 'M d, Y':
      formattedString = `${intl.formatMessage({id: `Date.Month${date.getMonth()}`})} ${date.getDate()}, ${date.getFullYear()}`;
      break;
    default:
      formattedString = `${date.getDate()} ${intl.formatMessage({id: `Date.Month${date.getMonth()}`})} ${date.getFullYear()}`;
      break;
  }
  return (process.env.REACT_APP_USE_LOWER_CASE !== 'true') ? formattedString : formattedString.toLowerCase();
};

// Allow creating dates from dateString and timestamp.
const createNewDate = (date) => {
  if (date && typeof date.getMonth === 'function') {
    return date;
  }

  // Check if date string contains time.
  const hasTime = /[+-]\d\d:\d\d$/.test(date);
  // If date string doesn't contain time pass time to prevent convert to local timezone.
  if (!hasTime) {
    return isNaN(date) ? new Date(`${date}T00:00:00`) : new Date(date);
  }
  return isNaN(date) ? new Date(date) : new Date(date);
};

export {customDateFormat, createNewDate};
